<div *ngIf="isReview" class="review-dialog">
  <div class="review-dialog__header">
    <h1 [translate]="'city-profile-certification/indicator/view-evidence'" class="review-dialog__title"></h1>
    <button mat-icon-button (click)="onCancel()">
        <i class="fal fa-times review-dialog__close-icon"></i>
    </button>
  </div>

  <div class="review-dialog__content">
    <pdf-viewer
      *ngIf="fileUrl"
      [src]="fileUrl"
      [render-text]="true"
      [stick-to-page]="true"
      [original-size]="true"
      [fit-to-page]="false"
      [zoom-scale]="'page-width'"
      class="review-dialog__pdf"
    />

    <mat-form-field *ngIf="link" appearance="fill" class="full-width-field">
      <mat-label [translate]="'city-profile-certification/indicator/url'">URL</mat-label>
      <input [formControl]="linkCtrl" matInput maxlength="500">
      <mat-hint align="end">
          {{linkCtrl.value.length}}/500
      </mat-hint>
    </mat-form-field>

    <div class="review-dialog__description">
      <div [translate]="'city-profile-certification/indicator/description'">
          Descrição
      </div>
      <textarea [formControl]="descriptionCtrl" class="review-dialog__description-field"></textarea>
    </div>
  </div>

  <button (click)="onCancel()" class="review-dialog__close-button" mat-button> <!-- It's causing modal overflow -  -->
      <span [translate]="'city-profile-certification/indicator/close'">Fechar</span>
  </button>
</div>

<ng-container *ngIf="!isReview">
  <mat-dialog-content >
    <div class="row">
      <div class="col">
        <h1 [translate]="'city-profile-certification/indicator/attach-file'">Anexar evidencias</h1>
      </div>
      <div class="col-auto">
        <button mat-icon-button (click)="onCancel()">
          <i class="fal fa-times"></i>
        </button>
      </div>
    </div>

    <form [formGroup]="form">
      <ng-container *ngIf="evidenceType === 'DOCUMENT'">
        <ng-container *ngIf="file">
          <div class="row align-items-center">
            <div class="col-auto text-info-upload">
              {{file.name}}
            </div>
            <div class="col-auto">
              <button mat-icon-button (click)="clearFile()">
                <i class="fal fa-trash-alt"></i>
              </button>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!file">
          <div class="row">
            <div class="col-12">
              <div class="text-info-upload" [translate]="'city-profile-certification/indicator/only-pdf'">
                Somente upload de arquivo PDF
              </div>
            </div>
            <div class="col-12">
              <div class="dropzone-container">
                <div class="row justify-content-center">
                  <div class="col-12 col-md-10">
                    <ngx-dropzone class="ng2FileDrop dropzone-reset-padding" [ngClass]="{ 'has-file': hasFile }" (change)="fileOver($event)"
                      style="padding: 0;">
                      <ngx-dropzone-label class="text-center">
                        <i class="icon fal fa-upload"></i>
                        <em [translate]="'city-profile-certification/indicator/drag-drop'">Arraste e solte o arquivo
                          aqui</em>
                        <div class="row justify-content-center">
                          <div class="col-auto">
                            <button class="btn btn-outline-light upload-select-button" type="button" style="pointer-events: none;">
                              <span [translate]="'city-profile-certification/indicator/select-file'">SELECIONAR
                                ARQUIVO</span>
                            </button>
                          </div>
                        </div>
                      </ngx-dropzone-label>
                    </ngx-dropzone>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <span class="text-info-upload mr-1" [translate]="'city-profile-certification/indicator/max-file-size'">
                Peso máximo: 10MB.
              </span>
              <span class="text-info-upload">10MB</span>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="evidenceType === 'LINK'">
        <div class="row mt-3">
          <div class="col-auto description-label">
            URL
          </div>
          <div class="col-12">
            <mat-form-field appearance="fill" class="full-width-field" style="width: 100%;">
              <input formControlName="link" matInput maxlength="500">
              <mat-hint align="end" *ngIf="form.get('link').value">
                {{form.get('link').value.length}}/500
              </mat-hint>
            </mat-form-field>
          </div>
        </div>
      </ng-container>

      <div class="row mt-3">
          <div class="col-auto description-label" [translate]="'city-profile-certification/indicator/description'">
              Descrição
          </div>
          <div class="col-12">
              <mat-form-field appearance="fill" class="full-width-field" style="width: 100%;">
                  <mat-label [translate]="'city-profile-certification/indicator/type-description'">Escreva sua
                      descrição</mat-label>
                  <textarea [rows]="5" formControlName="description" matInput maxlength="200"></textarea>
                  <mat-hint align="end" *ngIf="form.get('description').value">
                      {{form.get('description').value.length}}/200
                  </mat-hint>
              </mat-form-field>
          </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="row justify-content-end">
      <div class="col-auto btn-cancel">
        <button mat-button (click)="onCancel()">
          <span [translate]="'city-profile-certification/indicator/cancel'">Cancelar</span>
        </button>
      </div>
      <div class="col-auto btn-confirm">
        <button mat-button (click)="onSubmit(form)" cdkFocusInitial>
          <span [translate]="'city-profile-certification/indicator/save'"></span>
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</ng-container>
